export default __webpack_public_path__ + "static/media/A2B.ba9bc515.jpeg";